import React from 'react';
import styled from 'styled-components';

const Button = styled.a`
  padding: 15px 30px;
  font-size: 1.2rem;
  border-radius: 30px;
  background: #e1d6c0;
  color: #0d0d0d;
  font-weight: 700;
  transition: opacity 0.2s;
  &:hover { opacity: 0.8; }
`;

const OrderButtonDoorDash = () => (
  <Button href="https://order.online/store/-25039044/?pickup=true&hideModal=true&utm_source=gfo&rwg_token=AAiGsoa2ocPMPo1d0L6-x-yfGvWGSsoovzavjrsnTIjSlPXTmzp7wFK8NF1R1Q-U7QHVuS6KotmiRbB9TEshseUT2M5E2FZO5A%3D%3D" target="_blank" rel="noopener noreferrer">
    Order Delivery (DoorDash)
  </Button>
);

export default OrderButtonDoorDash;